import { SupabaseService } from "../../services/supabase.service";
import { TipsReport, TipsReportItem } from "../../models/reports.model";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";

const tipsTables = [
  'user',
  'job_user',
  'payment',
  'client_invoice',
  'invoice_version',
  'invoice_version_client',
];

export function tipsPendingListCountAndSum(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'tips_pending_report_count_and_sum',
      schema: businessId,
      fn: 'tips_pending_report_count_and_sum',
      tables: tipsTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(data => data[0])
  );
}

export function tipsPendingAll(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'tips_pending_report_all',
      schema: businessId,
      fn: 'tips_pending_report_all',
      tables: tipsTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  );
}

export function initTipsPending(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return combineLatest([
    tipsPendingListCountAndSum(
      supabaseService,
      businessId,
      selectedUsers,
      startTime,
      endTime
    ),
    tipsPendingAll(
      supabaseService,
      businessId,
      selectedUsers,
      startTime,
      endTime
    )
  ]).pipe(
    map(([countAndSum, allPendingTips]) => {
      return {
        type: 'pending',
        pending: (countAndSum as any).tipsSum as unknown as number,
        count: (countAndSum as any).tipsCount as unknown as number,
        allPendingTips: allPendingTips as unknown as TipsReportItem[]
      } as TipsReport;
    })
  );
}

export function tipsPaidListCountAndSum(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'tips_paid_report_count_and_sum',
      schema: businessId,
      fn: 'tips_paid_report_count_and_sum',
      tables: tipsTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(data => data[0])
  );
}

export function initTipsPaid(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return tipsPaidListCountAndSum(
    supabaseService,
    businessId,
    selectedUsers,
    startTime,
    endTime
  ).pipe(
    map((countAndSum) => {
      return {
        type: 'paid',
        paid: (countAndSum as any).tipsSum as unknown as number,
        count: (countAndSum as any).tipsCount as unknown as number,
      } as TipsReport;
    })
  );
}
